// @flow

/**
 * Module dependencies.
 */

import { identity } from 'lodash';

/**
 * `TeamMember` type.
 */

type TeamMember = {
  description: string,
  image: string,
  key: string,
  name: string,
  occupation: string
};

/**
 * `Team` entity.
 */

export default (translate: Function = identity): Array<TeamMember> => [{
  description: translate('team.carlosVeiga.description'),
  image: 'team/carlos-veiga',
  key: 'carlos-veiga',
  name: translate('team.carlosVeiga.name'),
  occupation: translate('team.carlosVeiga.occupation')
}, {
  description: translate('team.jorgePereira.description'),
  image: 'team/jorge-pereira',
  key: 'jorge-pereira',
  name: translate('team.jorgePereira.name'),
  occupation: translate('team.jorgePereira.occupation')
}, {
  description: translate('team.thomasBrooke.description'),
  image: 'team/thomas-brooke',
  key: 'thomas-brooke',
  name: translate('team.thomasBrooke.name'),
  occupation: translate('team.thomasBrooke.occupation')
}, {
  description: translate('team.timothyParsa.description'),
  image: 'team/timothy-parsa',
  key: 'timothy-parsa',
  name: translate('team.timothyParsa.name'),
  occupation: translate('team.timothyParsa.occupation')
}, {
  description: translate('team.winstonLing.description'),
  image: 'team/winston-ling',
  key: 'winston-ling',
  name: translate('team.winstonLing.name'),
  occupation: translate('team.winstonLing.occupation')
}];



// WEBPACK FOOTER //
// ../src/client/core/entities/team.js